import React, { Component } from 'react';
import { connect } from 'react-redux';

import Spinner from '../../components/generics/Spinner';
import SelectIntermediateLabels from '../../components/sessions/SelectIntermediateLabels';
import Alert from '../../utils/Alert';

import {
  fetchSession,
  fetchSessionSuccess,
  fetchSessionFailure,
  createIntermediateLabels,
  createIntermediateLabelsSuccess,
  createIntermediateLabelsFailure,
} from "../../store/sessions/actions";

import _ from 'lodash';
import { withRouter } from "utils/WithRouter";

export class ProductionIntermediateLabelsContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errors: [],
      items: [],
      allSelected: false,
    }

    this.alertRef = React.createRef();
  }

  componentDidMount() {
    this.props.fetchSession(this.props.match.params.id);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.session && this.props.session) {
      if (this.props.session.is_finished){
        prevProps.history.push('/session/' + prevProps.match.params.id)
      } else if (!this.props.session.temporary_products && !this.props.session.intermediate_labels) {
        this.alertRef.current.sendAlert('Current production session has no product labels to print!');
        prevProps.history.push('/session/' + prevProps.match.params.id + '/edit');
      } else {
        let items = this.props.session.temporary_products ? this.props.session.temporary_products : [];
        items.forEach(i => { i.selected = false });
        this.setState({ items });
      }
    }
  }

  toggleCheckBox = (event) => {
    let index = parseInt(event.target.value, 0),
    items = this.state.items.slice();
    items[index].selected = !items[index].selected;
    this.setState({ items, allSelected: false });
  };

  selectAll = () => {
    let allSelected = !this.state.allSelected;
    let items = this.state.items.slice();
    items.forEach(i => { i.selected = allSelected });
    this.setState({allSelected, items});
  };

  continuePrinting = () => {
    let selectedItems = _.filter(this.state.items, item => item.selected)
    selectedItems = {'items': _.map(selectedItems, 'id')}
    this.props.createIntermediateLabels(this.props.match.params.id, selectedItems, this.props.history);
  };

  goBack = () => {
    this.props.history.push('/session/' + this.props.match.params.id + '/edit')
  };

  render() {
    if(!this.props.session || this.props.session.loading) {
      return (
        <div>
          <Spinner />
          <Alert ref={this.alertRef}/>
        </div>
      );
    } else {
      return (
        <div>
          <Alert ref={this.alertRef}/>
          <div className="card">
            <div className="card-header d-flex justify-content-between align-items-center border-none">
              <h4 className="hidden-xs-down m-0">Select Labels</h4>
              <h5 className="hidden-sm-up m-0">Select Labels</h5>
                <div className="text-right">
                  <span onClick={this.goBack} className="btn btn-danger m-0 mr-05 hidden-xs-down"> Cancel </span>
                  <span onClick={this.continuePrinting} className="btn btn-primary m-0 hidden-xs-down"> Continue </span>
                  <span onClick={this.goBack} className="btn btn-danger m-0 mr-05 hidden-sm-up m-0"><i className="fa fa-times"></i></span>
                  <span onClick={this.continuePrinting} className="btn btn-primary m-0 hidden-sm-up m-0"><i className="fa fa-arrow-right"></i></span>
                </div>
            </div>
          </div>
          <SelectIntermediateLabels
            items={this.state.items}
            toggleCheckBox={this.toggleCheckBox}
            selectAll={this.selectAll}
            allSelected={this.state.allSelected} />
        </div>
    );
    }
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    session: state.sessions.sessionDetail.session
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchSession: (sId) => {
      dispatch(fetchSession(sId)).payload.then((response) => {
        dispatch(fetchSessionSuccess(response.data))
      }, (error) => {
        dispatch(fetchSessionFailure(error));
      });
    },
    createIntermediateLabels: (sessionId, data, history) => {
        dispatch(createIntermediateLabels(sessionId, data)).payload.then((response) => {
          dispatch(createIntermediateLabelsSuccess(response.data))
          history.push('/session/' + sessionId + '/labels?intermediate_labels=true');
      }, (error) => {
        dispatch(createIntermediateLabelsFailure(error));
      });
    },
  };
};

export default connect(mapStateToProps,  mapDispatchToProps)(withRouter(ProductionIntermediateLabelsContainer));
